import React from "react"
import { Link } from "gatsby"
import { useTranslation } from 'react-i18next';


const SummerSchoolHeaderLinks = (props) => {
  const schoolPathName = props.props.school.resolvedPath;
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  return (
    <div className="school-item-navigation-bar f-js f-ac flex-wrap gap-4 ps-8 pt-4">
      <Link to={`/${currentLang}/summer-schools/${schoolPathName}`} >
        <div className={`school-nav-bar-option ${props.props.state1}`}>{t('school.header.overview')}</div>
      </Link>
      <Link to={`/${currentLang}/summer-schools/${schoolPathName}/about`}>
        <div className={`school-nav-bar-option ${props.props.state2}`}>{t('school.header.about')}</div>
      </Link>
      <Link to={`/${currentLang}/summer-schools/${schoolPathName}/gallery`}>
        <div className={`school-nav-bar-option ${props.props.state3}`}>{t('school.header.gallery')}</div>
      </Link>
      <Link to={`/${currentLang}/summer-schools/${schoolPathName}/fees/active`}>
        <div className={`school-nav-bar-option ${props.props.state4}`}>{t('school.header.fees')}</div>
      </Link>
      <Link to={`/${currentLang}/summer-schools/${schoolPathName}/study-centers`}>
        <div className={`school-nav-bar-option ${props.props.state5}`}>{t('school.header.study-centers')}</div>
      </Link>
      <Link to={`/${currentLang}/summer-schools/${schoolPathName}/contacts`}>
        <div className={`school-nav-bar-option ${props.props.state8}`}>{t('school.header.contacts')}</div>
      </Link>
    </div>
  )
}

export default SummerSchoolHeaderLinks
